export const inlineLoadingStyles = `
  @keyframes kolegaExpandIn {
    0% { opacity: 0; transform: scale(0.8) translateY(10px); }
    100% { opacity: 1; transform: scale(1) translateY(0); }
  }
  @keyframes kolegaFloatOrbit {
    0% { transform: rotate(0deg) translateX(40px) rotate(0deg) scale(1); }
    33% { transform: rotate(120deg) translateX(45px) rotate(-120deg) scale(1.2); }
    66% { transform: rotate(240deg) translateX(35px) rotate(-240deg) scale(0.8); }
    100% { transform: rotate(360deg) translateX(40px) rotate(-360deg) scale(1); }
  }
  @keyframes kolegaDrift {
    0%, 100% { transform: translate(0, 0) scale(1); }
    25% { transform: translate(20px, -15px) scale(1.1); }
    50% { transform: translate(-15px, 10px) scale(0.9); }
    75% { transform: translate(10px, -5px) scale(1.05); }
  }
  @keyframes kolegaPulseGlow {
    0%, 100% { box-shadow: 0 0 20px rgba(173, 221, 48, 0.6), 0 0 40px rgba(173, 221, 48, 0.3), inset 0 0 15px rgba(255, 255, 255, 0.2); }
    50% { box-shadow: 0 0 30px rgba(173, 221, 48, 0.8), 0 0 60px rgba(173, 221, 48, 0.4), inset 0 0 20px rgba(255, 255, 255, 0.3); }
  }
  @keyframes kolegaCodePulse {
    0%, 100% { transform: scale(1) rotate(0deg); filter: drop-shadow(0 0 10px #ADDD30) drop-shadow(0 0 20px #ADDD30); }
    50% { transform: scale(1.1) rotate(5deg); filter: drop-shadow(0 0 20px #C4F03E) drop-shadow(0 0 40px #ADDD30); }
  }
  @keyframes kolegaNeonFlicker {
    0%, 100% { opacity: 1; }
    92% { opacity: 1; }
    93% { opacity: 0.8; }
    94% { opacity: 1; }
    95% { opacity: 0.9; }
    96% { opacity: 1; }
  }
  @keyframes kolegaBracketSlide {
    0%, 100% { transform: translateX(0); }
    50% { transform: translateX(-2px); }
  }
  @keyframes kolegaSlashRotate {
    0%, 100% { transform: rotate(0deg); }
    50% { transform: rotate(10deg); }
  }
  @keyframes kolegaTextShimmer {
    0%, 100% { opacity: 0.8; transform: translateX(0); }
    50% { opacity: 1; transform: translateX(2px); }
  }

  .kolega-loader-wrapper {
    animation: kolegaExpandIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
    background: transparent;
    transition: all 0.3s ease;
    position: relative;
    overflow: visible;
  }
  .kolega-bubble-field { position: absolute; inset: -60px; pointer-events: auto; }
  .kolega-bubble {
    position: absolute;
    border-radius: 50%;
    background: radial-gradient(circle at 30% 30%, #C4F03E, #ADDD30);
    animation: kolegaPulseGlow 2s ease-in-out infinite;
    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    cursor: pointer;
  }
  .kolega-bubble-orbit {
    width: 18px; height: 18px; top: 50%; left: 50%; 
    margin: -9px 0 0 -9px; opacity: 0.9;
  }
  .kolega-bubble-orbit-1 { animation: kolegaFloatOrbit 5s linear infinite; }
  .kolega-bubble-orbit-2 { animation: kolegaFloatOrbit 5s linear infinite reverse; animation-delay: -1.67s; }
  .kolega-bubble-orbit-3 { animation: kolegaFloatOrbit 5s linear infinite; animation-delay: -3.33s; }
  .kolega-bubble-drift { width: 22px; height: 22px; opacity: 0.8; }
  .kolega-bubble-drift-1 { top: 20%; left: 10%; animation: kolegaDrift 6s ease-in-out infinite; }
  .kolega-icon-container {
    animation: kolegaCodePulse 3s ease-in-out infinite, kolegaNeonFlicker 8s linear infinite;
    position: relative; z-index: 2;
  }
  .kolega-icon-bracket-left { animation: kolegaBracketSlide 2s ease-in-out infinite reverse; }
  .kolega-icon-bracket-right { animation: kolegaBracketSlide 2s ease-in-out infinite; }
  .kolega-icon-slash { transform-origin: center; animation: kolegaSlashRotate 2s ease-in-out infinite; }
  .kolega-text-wrapper {
    animation: kolegaTextShimmer 3s ease-in-out infinite;
    transition: opacity 0.3s ease-in-out;
  }
  .kolega-text-wrapper.transitioning { opacity: 0.3; }
`;
